/** Bot label that pairs with the `mo_contact_center` role to enable the contact-center overlay. */
export const CONTACT_CENTER_LABEL = 'contact-center';

/** Call-history grid column: name of the person transferred to. */
export const TRANSFER_CONTACT_FIELD = 'call_analysis_transferContact';

/** Destination number on `transferred_contact`. */
export const TRANSFER_PHONE_FIELD = 'call_analysis_transferPhone';

/** Pinned so the transfer and ticket chips stay visible while the grid scrolls sideways. */
export const CALL_ANALYSIS_CATEGORY_FIELD = 'call_analysis_category';

/** Contact-center grid only. Transfer phone/name stay on; test-user/stickers optional. */
export const CALL_ANALYSIS_HIDDEN_BY_DEFAULT = ['testUser', 'stickers'];

/** `HistoryFilter` fields matched inside the call-history session aggregation. */
export const TRANSFER_CONTACT_FILTER = 'transferContact';
export const TRANSFER_PHONE_FILTER = 'transferPhone';

export const CALL_ANALYSIS_ENDING_FIELD = 'call_analysis_ending';
export const CALL_ANALYSIS_ASK_FIELD = 'call_analysis_ask';
export const CALL_ANALYSIS_SENTIMENT_FIELD = 'call_analysis_sentiment';
export const CALL_ANALYSIS_LANGUAGE_FIELD = 'call_analysis_language';

export const CALL_ANALYSIS_ENDING_FILTER = 'callAnalysisEnding';
export const CALL_ANALYSIS_ASK_FILTER = 'callAnalysisAsk';
export const CALL_ANALYSIS_SENTIMENT_FILTER = 'callAnalysisSentiment';
export const CALL_ANALYSIS_LANGUAGE_FILTER = 'callAnalysisLanguage';
export const CALL_ANALYSIS_CATEGORY_FILTER = 'callAnalysisCategory';

/** Dashboard / call-history URL query params for analysis deep links. */
export const CALL_ANALYSIS_ENDING_PARAM = 'callAnalysisEnding';
export const CALL_ANALYSIS_ASK_PARAM = 'callAnalysisAsk';
export const CALL_ANALYSIS_SENTIMENT_PARAM = 'callAnalysisSentiment';
export const CALL_ANALYSIS_LANGUAGE_PARAM = 'callAnalysisLanguage';
export const CALL_ANALYSIS_CATEGORY_PARAM = 'callAnalysisCategory';

/** Chart deep link → call history; return opens the bot stats modal. */
export const FROM_BOT_STATS_PARAM = 'fromStats';
/** `/bots?openStats=<botId>` opens that bot's stats modal. */
export const OPEN_BOT_STATS_PARAM = 'openStats';

/** Ticket page query params: selected ticket and per-caller history. */
export const TICKET_ID_PARAM = 'ticket_id';
export const TICKET_PHONE_NUMBER_PARAM = 'phone_number';

/** `analytic_events[].type` carrying the LLM analysis of a finished call. */
export const CALL_ANALYSIS_EVENT_TYPE = 'call_analysis';

export const CALL_ENDINGS = [
    'transferred_to_contact',
    'transferred_to_operator',
    'ticket_filed',
    'other',
] as const;

/** What the caller asked for; survives a refusal, so a call can end `other` and still ask. */
export const CALLER_ASKS = [
    'wants_contact',
    'wants_ticket',
    'wants_operator',
    'wants_something_else',
] as const;

export const CALL_CATEGORIES = [
    'transfer_contact',
    'transfer_operator',
    'ticket',
    'other',
] as const;

export const CALL_CATEGORY_BY_ASK = {
    wants_contact: 'transfer_contact',
    wants_operator: 'transfer_operator',
    wants_ticket: 'ticket',
    wants_something_else: 'other',
} as const satisfies Record<
    (typeof CALLER_ASKS)[number],
    (typeof CALL_CATEGORIES)[number]
>;

export const SENTIMENTS = ['positive', 'neutral', 'negative'] as const;

export const ANALYTICS_DISTRIBUTIONS = [
    'endings',
    'languages',
    'sentiments',
] as const;
